import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetConfigStatusResponse } from './get-config-status-response';
import { getConfigStatusResponseSchema } from './get-config-status-response';

export async function getConfigStatusApi(): Promise<IValidatedResponse<IGetConfigStatusResponse>> {
  return getRequest<IGetConfigStatusResponse>({
    path: '/sys/configs',
    schema: getConfigStatusResponseSchema,
  });
}
